type Status = 'success' | 'warning' | 'danger' | 'info' | 'neutral'

interface StatusBadgeProps {
  status: Status
  label: string
}

export default function StatusBadge({ status, label }: StatusBadgeProps) {
  const badgeClass = `badge badge-${status}`

  return <span className={badgeClass}>{label}</span>
}
